<template>
    <ls-modal
        :options="modals.oneTimeMowingNotAvailable"
        @onModalClose="closeModal('oneTimeMowingNotAvailable')"
    >
        <div slot="header">
            <h3 class="ls-align--center ls-color--green ls-margin--top-none">
                Why are one-time mows not available in my area?
            </h3>
        </div>

        <div class="grid">
            <div class="grid__col-sm-12">
                <p data-font-size="-1">
                    Unfortunately, accomodating a one-time mow is difficult &mdash; scheduling one
                    requires a crew to rearrange their entire route. Because of this, only a small
                    number of crews in your area offer one-time mows, and they are completely booked
                    at the moment.
                </p>
            </div>
        </div>

        <div slot="button" class="grid">
            <div class="grid__col-12">
                <div>
                    <button
                        slot="button"
                        class="ls-float-right ls-button ls-button--white"
                        type="button"
                        @click="closeModal('oneTimeMowingNotAvailable')"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </ls-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import lsModal from '@/components/original-mydot/modals/modal/Modal.vue';

export default {
    components: {
        lsModal,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(['modals']),
    },
    methods: {
        ...mapActions({
            closeModal: types.MODAL__CLOSE_MODAL,
        }),
    },
};
</script>

<style lang="scss"></style>
